<template>
  <div class="IDC" id="IDC">
    <v-app>
      <v-app-bar app color='primary' dark height="564" absolute>
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar :pc='pc' :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor"></FirstNavbar>
          <div class="first_title_box" style="width:100%;height:calc(564px - 148px);" >
            <v-row align="center" justify="center">
              <v-col  cols="12">
                <h1 class="first_title">
                  数据中心
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <div style="width:50%;height:84px;display:flex;justify-content:center;margin:auto;padding-bottom:34px" >
            <v-row justify="space-around" class='dataCenterIconList'>
              <div class="text-center" style="font-size:2rem;line-height:2rem" >
                  <animate-number
                    from="1"
                    to="10000"
                    duration="1500"
                    easing="easeOutQuad"
                  ></animate-number>+<br><v-icon color="white darken-2 Sans-serif" class="body_text">机架</v-icon>
              </div>
              <v-divider vertical></v-divider>
              <div class="text-center" style="font-size:2rem;line-height:2rem" >
                  <animate-number
                    from="1"
                    to="60000"
                    duration="1500"
                    easing="easeOutQuad"
                  ></animate-number>+<br><v-icon color="white darken-2" class="body_text">机房面积</v-icon>
              </div>
              <v-divider vertical></v-divider>
              <div class="text-center">
                <v-icon large color="white darken-2" class="Sans-serif">A+</v-icon><br><v-icon color="white darken-2" class="body_text">等级认证</v-icon>
              </div>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/bg_IDC.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <v-app-bar
          :fixed='second_bar_fixed'
          prominent
          height="64"
          color="white"
          :flat='!second_bar_fixed'
        >
          <v-tabs v-model="second_active_tab" centered>
            <v-tab v-for="tab in contentList" :key='tab.index'  @click="goTo(tab.index)" class="body_text">{{tab.firstTitle}}</v-tab>
          </v-tabs>
        </v-app-bar>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12">
              <!-- 区位 -->
              <BoxTitle :firstTitle="contentList[0].firstTitle" :desc="contentList[0].desc" :index="contentList[0].index"></BoxTitle>
              <BoxLr :data='contentList[0].children[0]'></BoxLr>
              <!-- 等级 -->
              <BoxTitle :firstTitle="contentList[1].firstTitle" :desc="contentList[1].desc"  :index="contentList[1].index"></BoxTitle>
              <BoxLr :data='contentList[1].children[0]' :left_img="true" :hide_icon="true"></BoxLr>
              <!-- 体量 -->
              <BoxTitle :firstTitle="contentList[2].firstTitle" :desc="contentList[2].desc" :index="contentList[2].index"></BoxTitle>
              <BoxLr :data='contentList[2].children[0]' :hide_icon="true"></BoxLr>
              <!-- 特色 -->
              <BoxTitle :firstTitle="contentList[3].firstTitle" :desc="contentList[3].desc" :index="contentList[3].index"></BoxTitle>
              <BoxLr :data='contentList[3].children[0]' :left_img="true" :hide_icon="true"></BoxLr>
              <!-- 运维服务 -->
              <BoxTitle :firstTitle="contentList[4].firstTitle" :desc="contentList[1].desc" :index="contentList[4].index"></BoxTitle>
              <BoxLr :data='contentList[4].children[0]' :hide_icon="true"></BoxLr>
             </v-col>
          </v-row>
        </div>
        <!-- 悬浮图标-回到顶部 -->
        <v-fab-transition>
          <v-btn
            v-show="!floatHidden"
            color="primary"
            fixed
            bottom
            right
            fab
            @click="goTo(0)"
          >
            <v-icon>mdi-arrow-up</v-icon>
          </v-btn>
        </v-fab-transition>

      </v-main>
    <v-footer  color="secondary" style="height:auto">
      <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
    </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'
import BoxLr from '../components/box-lr.vue'
import BoxTitle from '../components/box-title.vue'

export default {
  name: 'IDC',
  components: {
    FootContent,
    FirstNavbar,
    BoxLr,
    BoxTitle
  },
  data: () => ({
    // 机柜个数
    jigui_num: 0,
    // 面积数
    mianji_num: 0,
    // 是否为PC端
    pc: false,
    // 内容
    contentList: [{
      index: 1,
      desc: '',
      firstTitle: '占据核心区位',
      scrollTop: '',
      children: [{
        index: 1,
        src: 'idc_area.png',
        content: {
          title: '',
          body: '数据中心位于河北省保定市，为河北省“环京津都市圈”县（市）之一，属京津1小时经济圈<br>北距北京89公里、东距天津125公里，东南部与雄安新区接壤<br>地理区位优势得天独厚',
          btn: '',
          list: []
        }
      }]
    }, {
      index: 2,
      desc: '',
      firstTitle: '等级',
      scrollTop: '',
      children: [{
        index: 1,
        src: 'idc_level.jpg',
        content: {
          title: '',
          body: '',
          btn: '',
          list: [{
            index: 1,
            src: '',
            title: '机房等级&emsp;&emsp;&emsp;A级增强型',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '机房面积&emsp;&emsp;&emsp;12000m²',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '',
            title: '总电力&emsp;&emsp;&emsp;&emsp;12000kVA',
            subtitle: '',
            body: ''
          }, {
            index: 4,
            src: '',
            title: '单机柜功率&emsp;&emsp;4-4.4kW',
            subtitle: '',
            body: ''
          }, {
            index: 5,
            src: '',
            title: '以上参数来源：A座数据中心（已投用）',
            subtitle: '',
            body: ''
          }]
        }
      }]
    }, {
      index: 3,
      desc: '',
      firstTitle: '体量',
      scrollTop: '',
      children: [{
        index: 1,
        src: 'idc_tiliang.jpg',
        content: {
          title: '',
          body: '',
          btn: '',
          list: [{
            index: 1,
            src: '',
            title: '嘉旭福美自有数据中心建设面积超60000平方米',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '机架总规模10000台套',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '',
            title: '可容纳服务器100000+台',
            subtitle: '',
            body: ''
          }]
        }
      }]
    }, {
      index: 4,
      desc: '',
      firstTitle: '特色',
      scrollTop: '',
      children: [{
        index: 1,
        src: '数据中心特色.png',
        content: {
          title: '',
          body: '',
          btn: '',
          list: [{
            index: 1,
            src: '',
            title: '高可靠&emsp;&emsp;系统可靠并持续创新',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '高安全&emsp;&emsp;符合中国国家A类标准',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '',
            title: '高品质&emsp;&emsp;主要设备均采用世界著名品牌的产品，比如ABB、施耐德',
            subtitle: '',
            body: ''
          }, {
            index: 4,
            src: '',
            title: '人性化&emsp;&emsp;独立的人员办公楼，独立设置的客户展示区，供客户讨论的贵宾会议室',
            subtitle: '',
            body: ''
          }, {
            index: 5,
            src: '',
            title: '绿色技术&emsp;绿色理念,节能减排',
            subtitle: '',
            body: ''
          }, {
            index: 6,
            src: '',
            title: '优管理&emsp;&emsp;根据管理功能的需要，设置三重监控室',
            subtitle: '',
            body: ''
          }]
        }
      }]
    }, {
      index: 5,
      desc: '',
      firstTitle: '运维服务',
      scrollTop: '',
      children: [{
        index: 1,
        src: 'idc_huoban.jpg',
        content: {
          title: '',
          body: '',
          btn: { label: '了解更多', path: '/yunwei' },
          list: [{
            index: 1,
            src: '',
            title: '驻场团队',
            subtitle: '',
            body: ''
          }, {
            index: 2,
            src: '',
            title: '严谨的流程、协议和标准',
            subtitle: '',
            body: ''
          }, {
            index: 3,
            src: '',
            title: '完善的安全性',
            subtitle: '',
            body: ''
          }, {
            index: 4,
            src: '',
            title: '标准化',
            subtitle: '',
            body: ''
          }, {
            index: 5,
            src: '',
            title: '平台化',
            subtitle: '',
            body: ''
          }]
        }
      }]
    }],
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 导航栏是否隐藏
    barHide: true,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 一级导航选项卡
    first_active_tab: 1,
    // 二级导航选项卡
    second_active_tab: 0,
    // 二级导航是否冻结
    second_bar_fixed: false
  }),
  mounted () {
    this.goTo(0)
    // // 鼠标滚动事件监听
    window.addEventListener('scroll', this.handleScroll)
    this.$nextTick(() => {
      // 代码
      this.contentList.forEach((val, index, arry) => {
        this.contentList[index].scrollTop = document.documentElement.querySelector('#part' + this.contentList[index].index).offsetTop + 564
      })
    })
    var that = this
    that.whatScreen()
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },

  methods: {
    // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.pc = true
              }
            }
          }
        }
      }
    },
    // 一级导航跳转定位,在本地储存一个键值对
    toguid (path_, id) {
      const path = path_
      const Id = id
      // 将id储存为键值对
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    },
    //  鼠标滚动事件（导航栏是否透明、导航栏是否隐藏投影、导航选项卡切换，悬浮按钮是否出现）
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 500) {
        this.second_bar_fixed = true
        this.gotop = true
      } else {
        this.second_bar_fixed = false
        this.barColor = 'rgba(63, 81, 181,0)'
        this.gotop = false
      }
      if (scrollTop < this.contentList[0].scrollTop) {
        this.second_active_tab = 0
        this.floatHidden = false
      } else if (scrollTop > this.contentList[this.contentList.length - 1].scrollTop) {
        this.second_active_tab = this.contentList.length - 1
        this.floatHidden = false
      } else {
        for (var i = 1; i < this.contentList.length; i++) {
          if (i <= this.contentList.length) {
            if (scrollTop >= this.contentList[i - 1].scrollTop & scrollTop < this.contentList[i].scrollTop) {
              this.second_active_tab = i - 1
              this.floatHidden = false
            }
          }
        }
      }
    },
    goTo (index) {
      // console.log(this.secondTabs, ele)
      // var anchor = this.$el.querySelector(ele)
      // document.documentElement.scrollTop = anchor.offsetTop + 500
      if (index === 0) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      } else {
        document.body.scrollTop = document.documentElement.querySelector('#part' + this.contentList[index - 1].index).offsetTop + 564
        document.documentElement.scrollTop = document.documentElement.querySelector('#part' + this.contentList[index - 1].index).offsetTop + 564
      }
    }
  }

}
</script>

<style>

</style>
